import { Roles } from 'common/constants/roles';
import { RouteConfig,routeConfigs } from 'common/routes/routeConfig';

export const isDisabledRoute = (routeName: string, currentUserRoles: Roles[]) => {
    const routeDef = routeDefinitionByName(routeName, routeConfigs);
    if(!routeDef) {
        return true;
    }

    const filteredRoles = currentUserRoles.filter(role => {
        return (routeDef.roles?.includes(role));
    });
    return filteredRoles.length === 0;
};

export const routeDefinitionByName = (routeName: string, routeDefs: RouteConfig[]) : RouteConfig | null => {
    for (const routeDef of routeDefs) {
        if(routeDef.path === routeName) {
            return routeDef;
        }
        if(routeDef.children) {
            const childRoute = routeDefinitionByName(routeName, routeDef.children);
            if(childRoute) {
                return childRoute;
            }
        }
    }
    return null;
};
